export default __webpack_public_path__ + "static/backgroundPublisher-4710011c0f1a9894e69ee94e9bfe6648.jpg";